import { styled } from '@mui/material';
import { Box, Button, Stack, Text } from 'shell/components';

const FinishedSignupPage = ({ device, handleResendCode }) => {
    return (
        <VerifyEmailBox device={device}>
            <Stack alignItems={'center'}>
                <Text variant={'h6'}>Verify Your Email</Text>
            </Stack>
            <Stack alignItems={'center'} sx={{ marginTop: '28px' }}>
                <Text variant={'p1'} sx={{ textAlign: 'center' }}>
                    To complete the signup process, check your inbox to verify your email. You will receive an email in
                    the next 5 minutes.
                </Text>
            </Stack>
            <Stack alignItems={'center'} sx={{ marginTop: '41px' }}>
                <SignUpText variant={'p3'}>
                    Didn’t receive the email?{' '}
                    <Button
                        variant={'borderless'}
                        onClick={handleResendCode}
                        sx={{ textDecoration: 'underline', fontSize: '12px', fontWeight: '500' }}
                    >
                        Resend email
                    </Button>
                </SignUpText>
            </Stack>
        </VerifyEmailBox>
    );
};

const VerifyEmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        height: 'fit-content',
        ...(device === 'mobile' && {
            position: 'relative',
            width: '100%',
            padding: 0,
        }),
        ...(device === 'tablet' && {
            width: 365,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
        ...(device === 'desktop' && {
            width: 450,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
    };
});

const SignUpText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

export default FinishedSignupPage;
